import styled, { css } from 'styled-components';
import { media } from '@styles/breakpoints';

type SectionBackground = 'primary' | 'secondary' | 'tertiary' | 'inverse' | 'inverseDeep';
type SectionSpacing = 'sm' | 'md' | 'lg' | 'xl' | 'none';

const spacingMap: Record<SectionSpacing, string> = {
  none: '0',
  sm: '3rem',
  md: '5rem',
  lg: '8rem',
  xl: '10rem',
};

const spacingMapDesktop: Record<SectionSpacing, string> = {
  none: '0',
  sm: '4rem',
  md: '7rem',
  lg: '10rem',
  xl: '14rem',
};

export const Section = styled.section<{
  $bg?: SectionBackground;
  $spacing?: SectionSpacing;
}>`
  width: 100%;
  padding-block: ${({ $spacing = 'lg' }) => spacingMap[$spacing]};

  ${media.desktop} {
    padding-block: ${({ $spacing = 'lg' }) => spacingMapDesktop[$spacing]};
  }

  ${({ $bg = 'primary', theme }) => {
    const bgMap: Record<SectionBackground, ReturnType<typeof css>> = {
      primary: css`
        background-color: ${theme.semantic.background.primary};
      `,
      secondary: css`
        background-color: ${theme.semantic.background.secondary};
      `,
      tertiary: css`
        background-color: ${theme.semantic.background.tertiary};
      `,
      inverse: css`
        background-color: ${theme.semantic.background.inverse};
        color: ${theme.semantic.text.inverse};
      `,
      inverseDeep: css`
        background-color: ${theme.semantic.background.inverseDeep};
        color: ${theme.semantic.text.inverse};
      `,
    };
    return bgMap[$bg];
  }}
`;
